import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ClubStats } from "types/Legacy/ClubStats";
import { SetAuthorisationHeaders } from "components/auth/AuthorisationHeaders";

declare global {
  interface Window {
    env: {
      environment: string;
    };
  }
}

const calculateUrl = (): string => {
  const env = window.env.environment;
  if (env === "dev") return "https://dev.manvfatfootball.org/api";
  if (env === "uat") return "https://uat.manvfatfootball.org/api";
  return "https://www.manvfatfootball.org/api/ClubStats";
};

export const statsApi = createApi({
  reducerPath: "statsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: calculateUrl(),
    prepareHeaders: SetAuthorisationHeaders
  }),
  endpoints: (builder) => ({
    statsApi: builder.query<ClubStats, string>({
      query: () => "/ClubStats",     
      transformResponse: (response: any) => {
        return response.clubStatsData;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useStatsApiQuery, useLazyStatsApiQuery } = statsApi;
